import { useTheme } from "@/theme/ThemeProvider";
import { Stack } from "expo-router";

/**
 * Explizite Stack-Registrierung, damit Metro/Expo-Router die P3-Screens
 * (index, new, [caseId]) zuverlässig bindet und keine Alt-Routen greifen.
 */
export default function AnimalsLayout() {
  const { theme } = useTheme();
  return (
    <Stack
      screenOptions={{
        headerShown: false,
        contentStyle: { backgroundColor: theme.color.bg },
      }}
    >
      <Stack.Screen name="index" />
      <Stack.Screen name="new" />
      <Stack.Screen name="batch" />
      <Stack.Screen name="[caseId]" />
    </Stack>
  );
}
